import { render, staticRenderFns } from "./RightTabs1.vue?vue&type=template&id=0ed08158&scoped=true&"
import script from "./RightTabs1.vue?vue&type=script&lang=js&"
export * from "./RightTabs1.vue?vue&type=script&lang=js&"
import style0 from "./RightTabs1.vue?vue&type=style&index=0&id=0ed08158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed08158",
  null
  
)

export default component.exports